






















import './ClosableVideoPlayer.scss'
import VideoObject from '@/classes/VideoObject'
import FinalOutputPlayer from '@/components/FinalOutputPlayer'
import { StreamVariant, StreamType } from '@/types/streams'
import { defineComponent } from '@vue/composition-api'
import JanusVideoObject from '@/classes/JanusVideoObject'
import { Cast } from '@/modules/casts/classes'

export default defineComponent({
  name: 'ClosableVideoPlayer',
  components: {
    FinalOutputPlayer
  },
  props: {
    streamId: {
      type: String,
      required: true
    },
    cast: { // FIXME: A generic component shouldn't be needing a cast.
      type: Object as () => Cast,
      required: true
    },
    showMuteBtn: {
      type: Boolean,
      default: true
    },
    default: {
      type: Boolean,
      default: false
    },
    isJanus: {
      type: Boolean,
      default: false
    },
    streamUrl: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      isPreviewing: this.default,
      muted: true,
      videoObject: null as null|VideoObject|JanusVideoObject
    }
  },
  beforeDestroy () {
    this.closePreview()
  },
  methods: {
    // eslint-disable-next-line max-lines-per-function
    addOutputVideo (vid: { video: string, variant: StreamVariant }) {
      // eslint-disable-next-line unicorn/consistent-function-scoping
      const killStream = (stream: VideoObject|JanusVideoObject) => {
        this.$store.direct.dispatch.streams.deleteStreamFromManager(stream.id)
        this.closePreview()
      }
      // eslint-disable-next-line unicorn/consistent-function-scoping
      const callback = (video: VideoObject|JanusVideoObject) => {
        void this.addStreamToStreamManager(video.id, video)
      }
      // eslint-disable-next-line unicorn/consistent-function-scoping
      const restartStream = (video: VideoObject|JanusVideoObject) => {
        console.log('Stream Restarted', video)
      }
      if (this.videoObject !== null) {
        this.videoObject.stopPlay()
        this.videoObject = null
      }
      if (this.isJanus) {
        this.videoObject = new JanusVideoObject({
          id: vid.video,
          name: 'preview',
          url: vid.variant.url,
          chinaSupport: false,
          udpEnabled: this.$store.direct.getters.user.useUdp,
          logNetwork: false,
          callback,
          killStream,
          restartStream
        })
      } else {
        this.videoObject = new VideoObject({
          id: vid.video,
          name: 'preview',
          chinaSupport: false,
          logNetwork: false,
          streamToPlay: vid.variant,
          udpEnabled: this.$store.direct.getters.user.useUdp,
          callback,
          restartStream,
          killStream
        })
      }
    },
    closePreview () {
      if (this.videoObject === null) return
      this.videoObject.stopPlay()
      this.isPreviewing = false
    },
    addStreamToStreamManager (streamId: string, video: VideoObject|JanusVideoObject) {
      return this.$store.direct.dispatch.streams.addStreamToManager({
        id: streamId,
        srcObject: video.srcObject ?? null,
        type: StreamType.Output,
        leftrightsplit: false
      })
    }
  }
})

